//
//
//
//
//
//
//
//
//
//
//

import ArticleList from '~/pages/Article/_components/ArticleList';
import ArticleContentDetails from './_components/ArticleContentDetails';
import { isEmpty } from 'lodash';
const axios = require('axios');

export default {
  name: 'ArticleContent',
  components: {
    ArticleList,
    ArticleContentDetails,
  },
  data() {
    return {
      categoryId: 0,
      articleDetails: null,
    };
  },
  head() {
    return {
      title: `${this.ogTitle}`,
      meta: [
        {
          hid: 'url',
          property: 'url',
          content: `${this.url}`,
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `${this.url}`,
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: `${this.ogTitle}`,
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: `${this.ogDescription}`,
        },
        {
          hid: 'description',
          name: 'description',
          content: `${this.ogDescription}`,
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: `${this.keywords}`,
        },
      ],
      link: [{ rel: 'canonical', href: this.url }],
    };
  },
  async asyncData({ route, payload }) {
    let data = '',
      ogTitle = '',
      ogDescription = '',
      pageTitle = '',
      pageJobContent = '',
      jobHid = '',
      url = '',
      keywords = '';

    //SEO
    const lifecycle = process.env.npm_lifecycle_event;
    if (['generate', 'generate:dev'].includes(lifecycle)) {
      data = payload;
    } else {
      const apiURL = `${process.env.domainUrl}/apis/article/getOne?id=${route.params.id}`;
      try {
        const result = await axios.get(apiURL);
        data = result.data.data;
      } catch (e) {
        console.log('_id asyncData apiURL not found', e);
      }
    }

    if (!isEmpty(data)) {
      const detailData = data;
      pageTitle = detailData.title;
      pageJobContent = detailData.description;
      keywords = detailData.keyWord;
    }
    ogTitle = `${pageTitle} - 精選閱讀 | STEP1NE`;
    ogDescription = pageJobContent;
    url = `${process.env.domainUrl}/ArticleContent/${jobHid}`;

    return {
      url,
      ogTitle,
      keywords,
      ogDescription,
    };
  },
  methods: {
    getArticleDetail(id) {
      this.$api('getOneArticle', { id }).then(data => {
        this.articleDetails = data;
        this.categoryId = data.categoryId;
      });
    },
  },
  mounted() {
    const id = this.$route.params.id || 0;
    this.getArticleDetail(id);
  },
};
